import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'antd';
import './Landing.scss';

const Landing = () => (
  <div className="landing-page">
    <div className="landing-hero">
      <div className="landing-inner container">
        <h1 className="landing-title">Chiti — Simple expenses management &amp; notes</h1>
        <p className="landing-subtitle">
          Track expenses, take quick notes — fast and simple.
        </p>

        <div className="landing-ctas">
          <Link to="/login">
            <Button type="primary" size="large" className="landing-btn">
              <Icon type="login" /> Login
            </Button>
          </Link>

          <Link to="/signup">
            <Button size="large" className="landing-btn landing-btn-outline">
              <Icon type="user-add" /> Sign up
            </Button>
          </Link>
        </div>

        <div className="landing-features">
          <div className="feature">
            <h3>Quickly add &amp; split expenses</h3>
            <p>Add expenses in second.</p>
          </div>

          <div className="feature">
            <h3>Report by month &amp; date</h3>
            <p>Generate simple reports grouped by month or by date to review spending.</p>
          </div>

          <div className="feature">
            <h3>Notes</h3>
            <p>Keep short notes for yourself</p>
          </div>
        </div>
      </div>
    </div>

    <div className="landing-disclaimer">
      <small>
        <Link to="/terms">Terms &amp; Conditions</Link>
      </small>
    </div>
  </div>
);

export default Landing;
